import BgIndoorOffice from "./v2/styles/bg_indoor_office.png";
import BgOutdoorCity from "./v2/styles/bg_outdoor_city.png";
import BgOutdoorGarden from "./v2/styles/bg_outdoor_garden.png";
import BgStudioDarkGrey from "./v2/styles/bg_studio_dark_grey.png";
import BgStudioLightGrey from "./v2/styles/bg_studio_light_grey.png";
import BgStudioWhite from "./v2/styles/bg_studio_white.png";
import BgIndoorCafe from "./v2/styles/bg_indoor_cafe.png";
import BgStudioAubergine from "./v2/styles/bg_studio_aubergine.jpeg";
import BgStudioEmerald from "./v2/styles/bg_studio_dark_emerald_green.jpeg";
import BgBeachSunrise from "./v2/styles/bg_beach_sunrise.png";
import BgBeachBlueHour from "./v2/styles/bg_beach_bluehour.png";
import BgBeachSunset from "./v2/styles/bg_beach_sunset.png";
import BgBirthdayHome from "./v2/styles/bg_birthday_home.png";
import BgBirthdayStudio from "./v2/styles/bg_birthday_studio.png";
import BgUniversityCampus from "./v2/styles/bg_university_campus.jpeg";
import BgUniversityLibrary from "./v2/styles/bg_university_library.png";
import BgStudioConcreteWall from "./v2/styles/bg_studio_concrete_wall.png";
import BgStudioBrickWall from "./v2/styles/bg_studio_brick_wall.png";
import BgStudioDance from "./v2/styles/bg_studio_dance.png";
import BgHospital from "./v2/styles/bg_hospital.png";

import PicturePlaceholder from "./v2/styles/picture_placeholder.png";
import UploadPlaceholder from "./v2/upload_placeholder.png";
import indoor_cafe_f from "./people/indoor_cafe_f.png";
import indoor_cafe_m from "./people/indoor_cafe_m.png";
import indoor_hallway_f from "./people/indoor_hallway_f.png";
import indoor_hallway_m from "./people/indoor_hallway_m.png";
import indoor_office_f from "./people/indoor_office_f.png";
import indoor_office_m from "./people/indoor_office_m.png";
import outdoor_city_f from "./people/outdoor_city_f.png";
import outdoor_city_m from "./people/outdoor_city_m.png";
import outdoor_woods_f from "./people/outdoor_woods_f.png";
import outdoor_woods_m from "./people/outdoor_woods_m.png";
import studio_f from "./people/studio_f.png";
import studio_m from "./people/studio_m.png";

import cus2 from "./people/cus2.png";
import cus1 from "./people/cus1.png";
import welcomePhoto from "./welcome-photo.png";
import cus1a from "./people/cus1a.png";
import cus1b from "./people/cus1b.png";
import cus1c from "./people/cus1c.png";
import cus1d from "./people/cus1d.png";
import cus1e from "./people/cus1e.png";
import cus2a from "./people/cus2a.png";
import cus2b from "./people/cus2b.png";
import cus2c from "./people/cus2c.png";
import cus2d from "./people/cus2d.png";
import cus2e from "./people/cus2e.png";
import cus2f from "./people/cus2f.png";
import cus2g from "./people/cus2g.png";
import cus2h from "./people/cus2h.png";
import cus3a from "./people/cus3a.png";
import cus3b from "./people/cus3b.png";
import cus3c from "./people/cus3c.png";
import cus3d from "./people/cus3d.png";
import cus3e from "./people/cus3e.png";
import cus4a from "./people/cus4a.png";
import cus4b from "./people/cus4b.png";
import cus4c from "./people/cus4c.png";
import cus4d from "./people/cus4d.png";
import cus4e from "./people/cus4e.png";
import cus5 from "./people/cus5.png";
import cus5a from "./people/cus5a.png";
import cus5b from "./people/cus5b.png";
import cus5c from "./people/cus5c.png";
import cus6a from "./people/cus6a.png";
import cus6b from "./people/cus6b.png";
import cus6c from "./people/cus6c.png";
import cus7a from "./people/cus7a.png";
import cus7b from "./people/cus7b.png";
import cus7c from "./people/cus7c.png";
import snapglogo from "./snapg-logo.png";
import logoNName from "./logo-and-name.png";
import placeholderImg from "./placeholder-blank.jpg";
import loadingGif from "./img-loader.gif";

const images = {
  indoor_cafe_f,
  indoor_cafe_m,
  indoor_hallway_f,
  indoor_hallway_m,
  indoor_office_f,
  indoor_office_m,
  outdoor_city_f,
  outdoor_city_m,
  outdoor_woods_f,
  outdoor_woods_m,
  studio_f,
  studio_m,
  welcomePhoto,
  cus1,
  cus2,
  cus1a,
  cus1b,
  cus1c,
  cus1d,
  cus1e,
  cus2a,
  cus2b,
  cus2c,
  cus2d,
  cus2e,
  cus2f,
  cus2g,
  cus2h,
  cus3a,
  cus3b,
  cus3c,
  cus3d,
  cus3e,
  cus4a,
  cus4b,
  cus4c,
  cus4d,
  cus4e,
  cus5,
  cus5a,
  cus5b,
  cus5c,
  cus6a,
  cus6b,
  cus6c,
  cus7a,
  cus7b,
  cus7c,
  snapglogo,
  logoNName,
  placeholderImg,
  loadingGif,
  // v2
  BgIndoorCafe,
  BgIndoorOffice,
  BgOutdoorCity,
  BgOutdoorGarden,
  BgStudioDarkGrey,
  BgStudioLightGrey,
  BgStudioWhite,
  PicturePlaceholder,
  UploadPlaceholder,

  BgStudioAubergine,
  BgStudioEmerald,
  BgBeachSunrise,
  BgBeachBlueHour,
  BgBeachSunset,
  BgBirthdayHome,
  BgBirthdayStudio,
  BgUniversityCampus,
  BgUniversityLibrary,
  BgStudioConcreteWall,
  BgStudioBrickWall,
  BgStudioDance,
  BgHospital,
};

export type StyleImageName = keyof typeof images;
export default images;
